import {Component, Inject, OnInit,  ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Student} from "../../shared/interface/roster.interface";
import {RosterService} from "../../shared/roster.service";


@Component({
    selector: 'app-roster-roster-add-comment',
    templateUrl: './roster-add-comment.component.html',
    styleUrls: ['./roster-add-comment.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class RosterAddCommentComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<RosterAddCommentComponent>,
        public rosterService: RosterService,
        @Inject(MAT_DIALOG_DATA) public data: Student
    ) {
    }


    //local variables that is needed
    ngOnInit(): void {

    }

    saveNotes() {
        // save to database
        this.dialogRef.close(this.data);
    }

    onClose() {
        this.data.tempComment = null;
        this.dialogRef.close();
    }

}
